import ExpandSvg from '@assets/images/svg/expand.svg';
import React from 'react';
import { View } from 'react-native';

export interface ExpandIconProps {
    size?: number;
    color?: string;
}

export function ExpandIcon({ size = 20, color = '#333333' }: ExpandIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ExpandSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ExpandIcon;
